<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-icon
          @click="$emit('setDialog', false)"
          style="position:absolute;right:5px;padding-top:5px;"
        >close</v-icon>
        <v-card-text>
          <div class="pb-1" style="font-size:18px;">Waiting note :</div>
          <v-textarea v-model="select_item.msg" solo auto-grow hide-details></v-textarea>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer/>
          <v-btn flat color="red" class="black--text" @click="$emit('setDialog', false)">cancel</v-btn>
          <v-btn flat color="green darken-1" class="black--text" @click="$emit('save')">save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default() {
        return false;
      }
    },
    select_item: {
      type: Object,
      default() {
        return { msg: null };
      }
    }
  },
  data() {
    return {};
  }
};
</script>